module.exports = __webpack_public_path__ + "static/media/SmartDash_darkbg.2a7f4c0e.png";